(function () {
  if (document.documentElement.dataset.productGridScriptBound === 'true') {
    return;
  }

  document.documentElement.dataset.productGridScriptBound = 'true';

  let sectionResizeObserver;

  const calcMinHeight = () => {
    const facetsTop = document.querySelector('.facets__top');
    const sortWrapper = document.querySelector('.facets__sort-wrapper');

    if (facetsTop && sortWrapper) {
      facetsTop.style.minHeight = sortWrapper.getBoundingClientRect().height+'px';
    }
  }

  const resizeCollectionGrid = () => {
		const collectionGridSection = document.querySelector('.collection-grid-section') || document.querySelector('.section-search');

		if (sectionResizeObserver) {
			sectionResizeObserver.disconnect();
		}

		calcMinHeight();

		if (!collectionGridSection) return;

		sectionResizeObserver = new ResizeObserver(() => {
      calcMinHeight();
		});

		sectionResizeObserver.observe(collectionGridSection);
	}

  document.addEventListener('shopify:section:load', function () {
		resizeCollectionGrid();
	});

	document.addEventListener('shopify:section:unload', function () {
		if (sectionResizeObserver) {
			sectionResizeObserver.disconnect();
			sectionResizeObserver = null;
		}
	});

	resizeCollectionGrid();

})();